import { ErrorHandler, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WorkflowComponent } from './workflow/workflow.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { ClipboardModule } from 'ngx-clipboard';
import { BnsightsLibraryModule } from 'bnsights-control-library';
import { BlockUIModule } from 'ng-block-ui';
import { DataSecretService } from '../shared/Services/data.service';
import { HttpErrorInterceptor } from '../shared/Services/HttpErrorInterceptor.service';
import { ErrorService } from '../shared/Services/ErrorService.service';
import { AuthModule } from '../core/auth.module';
import { WorkflowsRoutingModule } from './workflows-routing.module';
import { TabsComponent } from './tabs/tabs.component';
import { WorkflowsComponent } from './workflows.component';
import { SubheaderModule } from '../_layout/components/subheader/subheader.module';
import { MatMenuModule } from '@angular/material/menu';
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { InlineSVGModule } from 'ng-inline-svg';
import { EmptyDataModule } from '../empty-data/empty-data.module';
import { AuthService, BBSFTranslateService, EnvironmentService, UtilityService } from 'bnsights-utilities-library';
import { WorkflowService } from '../shared/Services/WorkflowService.service';

@NgModule({
  declarations: [WorkflowComponent, TabsComponent, WorkflowsComponent],
  imports: [
    WorkflowsRoutingModule,
    CommonModule,
    ReactiveFormsModule,
    HttpClientModule,
    AuthModule,
    RouterModule,
    CommonModule,
    ClipboardModule,
    BlockUIModule.forRoot(),
    ReactiveFormsModule,
    FormsModule,
    BnsightsLibraryModule,
    SubheaderModule,
    MatMenuModule,
    NgbModule,
    InlineSVGModule,
    EmptyDataModule
  ],
  providers:[
    EnvironmentService,
    DataSecretService,
    UtilityService,
    AuthService,
    BBSFTranslateService,
    WorkflowService
    
  ]
})
export class WorkflowsModule { }
